import { makeAutoObservable, runInAction } from 'mobx';
import type { RootStore } from './root-store';

export type CompetitionDialogStoreHydration = {
    isOpened: boolean;
    confirmLoading: boolean;
    isCheckboxChecked: boolean;
};

export class CompetitionDialogStore {
    rootStore: RootStore;

    isOpened = false;

    confirmLoading = false;

    isCheckboxChecked = false;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this, {
            rootStore: false,
        });
    }

    hydrate(): CompetitionDialogStoreHydration {
        return {
            isOpened: this.isOpened,
            confirmLoading: this.confirmLoading,
            isCheckboxChecked: this.isCheckboxChecked,
        };
    }

    rehydrate(data: CompetitionDialogStoreHydration): void {
        this.isOpened = data.isOpened;
        this.confirmLoading = data.confirmLoading;
        this.isCheckboxChecked = data.isCheckboxChecked;
    }

    closeDialog(): void {
        this.isOpened = false;
    }

    openDialog(): void {
        this.isOpened = true;
    }

    switchIsCheckboxChecked(): void {
        this.isCheckboxChecked = !this.isCheckboxChecked;
    }

    startConfirmLoading(): void {
        this.confirmLoading = true;
    }

    stopConfirmLoading(): void {
        this.confirmLoading = false;
    }

    async confirmJoin(month: number, year: number): Promise<void> {
        this.startConfirmLoading();

        try {
            await this.rootStore.userStore.updateSettings({ ytdPerformanceCompetitor: true });
            this.closeDialog();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            this.rootStore.alertStore.setErrorMessageByStatus(e.message);
        } finally {
            runInAction(() => {
                this.rootStore.leaderboardStore.fetchLeaderboard(month, year);
            });
            this.stopConfirmLoading();
        }
    }
}
